module.exports = __webpack_public_path__ + "4e969e1795a718a7c257017b954146a1.png";